/**
 * ATW — Επιλογέας μορφής αρώματος (Κερί · Diffuser · Room spray …)
 *
 * Συνδέει προϊόντα με το ΌΝΟΜΑ του αρώματος (ό,τι υπάρχει πριν από το « | » του τίτλου)
 * και εμφανίζει τις διαθέσιμες μορφές. Νέες μορφές (π.χ. αρωματικό αυτοκινήτου) προστίθενται
 * αυτόματα μόλις υπάρξει προϊόν με το ίδιο όνομα αρώματος. Δεν αλλάζει URLs ή δεδομένα.
 *
 * Δεδομένα: /search/suggest.json (native Shopify predictive search). Cache: sessionStorage.
 *
 * ROLLBACK 02/10/2026: το quick add των καρτών (αρχική, συλλογές, αναζήτηση, προτάσεις καλαθιού) δεν
 * παρεμβάλλεται πια. Το κουμπί τσάντα συμπεριφέρεται όπως στο theme: άμεση προσθήκη όταν το προϊόν
 * έχει μία παραλλαγή, αλλιώς το native παράθυρο επιλογών. Στο native παράθυρο δεν μπαίνει πια ο
 * επιλογέας μορφών (μένει μόνο στη σελίδα προϊόντος).
 */
(() => {
  if (window.__atwFormatsLoaded) return;
  window.__atwFormatsLoaded = true;

  const CACHE_PREFIX = 'atw-formats-v1:';
  const CACHE_TTL = 10 * 60 * 1000;

  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const KIND_WORDS = /κερ|diffuser|spray|αρωματικ|χειροποι|fabric|mist/i;

  const scentName = (title) => {
    let name = String(title || '').split('|')[0];
    if (name.includes(' – ')) {
      const parts = name.split(' – ');
      if (parts.length > 1 && KIND_WORDS.test(parts[parts.length - 1])) parts.pop();
      name = parts.join(' – ');
    }
    return name.trim();
  };

  /* Το είδος του προϊόντος: ό,τι ακολουθεί το « | » ή το τελευταίο « – » (αν μοιάζει με είδος) */
  const suffixOf = (title) => {
    const t = String(title || '');
    const i = t.indexOf('|');
    if (i !== -1) return t.slice(i + 1);
    const j = t.lastIndexOf(' – ');
    return j !== -1 && KIND_WORDS.test(t.slice(j + 3)) ? t.slice(j + 3) : '';
  };

  const parseLines = (text) =>
    String(text || '')
      .split(/\r?\n/)
      .map((l) => l.trim())
      .filter(Boolean);

  const readCache = (key) => {
    try {
      const raw = JSON.parse(sessionStorage.getItem(CACHE_PREFIX + key) || 'null');
      if (raw && Date.now() - raw.t < CACHE_TTL) return raw.v;
    } catch (_) {
      /* χωρίς cache */
    }
    return null;
  };
  const writeCache = (key, value) => {
    try {
      sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify({ t: Date.now(), v: value }));
    } catch (_) {
      /* χωρίς cache */
    }
  };

  const money = (value) => {
    const n = parseFloat(value);
    if (Number.isNaN(n)) return '';
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat('el-GR', { style: 'currency', currency }).format(n);
    } catch (_) {
      return n.toFixed(2) + '€';
    }
  };

  const imageUrl = (p, width) => {
    const src = (p.featured_image && p.featured_image.url) || p.image || '';
    if (!src) return '';
    try {
      const u = new URL(src, location.origin);
      u.searchParams.set('width', String(width));
      return u.toString();
    } catch (_) {
      return src;
    }
  };

  const fetchSiblings = async (name) => {
    const key = norm(name);
    const cached = readCache(key);
    if (cached) return cached;
    const url =
      '/search/suggest.json?q=' +
      encodeURIComponent(name) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=title';
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(String(res.status));
    const data = await res.json();
    const list = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    const slim = list.map((p) => ({
      title: p.title,
      type: p.type || '',
      handle: p.handle,
      available: p.available !== false,
      price: p.price,
      img: imageUrl(p, 480),
    }));
    writeCache(key, slim);
    return slim;
  };

  /* ---------- Popup (ένα κοινό dialog) ---------- */
  let dialog = null;
  const ensureDialog = () => {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'atw-formats-dialog';
    dialog.setAttribute('aria-label', 'Μορφή αρώματος');
    dialog.innerHTML =
      '<button type="button" class="atw-formats-dialog__close" aria-label="Κλείσιμο">' +
      '<svg viewBox="0 0 18 18" width="14" height="14" aria-hidden="true"><path d="M3 3l12 12M15 3L3 15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
      '</button><div class="atw-formats-dialog__body"></div>';
    document.body.append(dialog);
    dialog.querySelector('.atw-formats-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });
    return dialog;
  };

  /* ---------- Γρήγορη προσθήκη στο καλάθι (μέσω της φόρμας του theme) ---------- */
  /* Χρησιμοποιούμε το ίδιο product-form-component του theme, ώστε να ενημερώνονται
     καλάθι, μετρητής και animation όπως σε κάθε άλλη προσθήκη. */
  const addToCart = async (item, opts, btn, dlg) => {
    if (btn.disabled) return;
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    const fail = (message) => {
      btn.textContent = message || original;
      btn.disabled = false;
      btn.removeAttribute('data-state');
    };
    try {
      const res = await fetch('/products/' + encodeURIComponent(item.handle) + '.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('product');
      const product = await res.json();
      const variants = (product.variants || []).filter((v) => v.available);
      if ((product.variants || []).length !== 1 || !variants.length) {
        /* Προϊόν με επιλογές: ο πελάτης διαλέγει στη σελίδα του */
        window.location.href = '/products/' + item.handle;
        return;
      }
      await customElements.whenDefined('product-form-component');
      const sectionHost = document.querySelector('[data-section-id]');
      const host = document.createElement('div');
      host.hidden = true;
      host.innerHTML =
        '<product-form-component data-section-id="' + ((sectionHost && sectionHost.dataset.sectionId) || '') + '" data-product-id="' + product.id + '" on:submit="/handleSubmit">' +
        '<div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>' +
        '<form method="post" action="/cart/add" novalidate data-type="add-to-cart-form">' +
        '<input type="hidden" name="id" ref="variantId" value="' + variants[0].id + '">' +
        '<input type="hidden" name="quantity" value="1"><button type="submit">add</button></form></product-form-component>';
      document.body.append(host);
      const form = host.querySelector('form');
      let eventsModule = null;
      try {
        eventsModule = await import('@shopify/events');
      } catch (_) {
        eventsModule = null;
      }
      const eventName = eventsModule && eventsModule.StandardEvents ? eventsModule.StandardEvents.cartLinesUpdate : null;
      let settled = false;
      const done = (ok) => {
        if (settled) return;
        settled = true;
        if (ok) {
          btn.textContent = opts.addedText;
          btn.setAttribute('data-state', 'added');
          setTimeout(() => {
            if (dlg && dlg.open) dlg.close();
            btn.disabled = false;
            btn.textContent = original;
            btn.removeAttribute('data-state');
          }, 1400);
        } else {
          fail(original);
        }
        setTimeout(() => host.remove(), 4000);
      };
      if (eventName) {
        host.addEventListener(eventName, (e) => {
          if (e.promise && e.promise.then) {
            e.promise.then(({ detail }) => done(!(detail && detail.didError))).catch(() => done(false));
          }
        });
      } else {
        setTimeout(() => done(true), 1500);
      }
      form.requestSubmit();
    } catch (_) {
      fail(original);
    }
  };

  const openDialog = (item, opts, opener) => {
    const d = ensureDialog();
    const body = d.querySelector('.atw-formats-dialog__body');
    body.textContent = '';

    const media = document.createElement('div');
    media.className = 'atw-formats-dialog__media';
    if (item.img) {
      const img = document.createElement('img');
      img.src = item.img;
      img.alt = '';
      img.loading = 'lazy';
      media.append(img);
    }

    const info = document.createElement('div');
    info.className = 'atw-formats-dialog__info';
    const kind = document.createElement('p');
    kind.className = 'atw-formats-dialog__kind';
    kind.textContent = item.label;
    const title = document.createElement('p');
    title.className = 'atw-formats-dialog__title';
    title.textContent = scentName(item.title);
    info.append(kind, title);

    if (opts.showPrice && item.price) {
      const price = document.createElement('p');
      price.className = 'atw-formats-dialog__price';
      price.textContent = money(item.price);
      info.append(price);
    }
    if (!item.available) {
      const sold = document.createElement('p');
      sold.className = 'atw-formats-dialog__sold';
      sold.textContent = opts.soldout;
      info.append(sold);
    }
    const link = document.createElement('a');
    link.className = 'atw-formats-dialog__cta';
    link.href = '/products/' + item.handle;
    link.textContent = opts.cta;
    info.append(link);

    if (item.available && opts.addText) {
      const add = document.createElement('div');
      add.className = 'atw-formats-dialog__add';
      if (opts.addPrompt) {
        const prompt = document.createElement('p');
        prompt.className = 'atw-formats-dialog__prompt';
        prompt.textContent = opts.addPrompt;
        add.append(prompt);
      }
      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'atw-formats-dialog__addbtn';
      addBtn.textContent = opts.addText;
      addBtn.addEventListener('click', () => addToCart(item, opts, addBtn, d));
      add.append(addBtn);
      info.append(add);
    }

    body.append(media, info);
    if (typeof d.showModal === 'function') d.showModal();
    else d.setAttribute('open', '');
    d.addEventListener(
      'close',
      () => {
        if (opener && opener.focus) opener.focus();
      },
      { once: true }
    );
  };

  /* ---------- Επιλογέας ---------- */
  const build = async (root) => {
    if (root.dataset.atwReady === '1') return;
    root.dataset.atwReady = '1';

    const title = root.dataset.title || '';
    const name = scentName(title);
    if (!name) return;

    const mapping = parseLines(root.dataset.mapping)
      .map((l) => {
        const i = l.indexOf('=');
        return i > 0 ? { k: norm(l.slice(0, i)), v: l.slice(i + 1).trim() } : null;
      })
      .filter(Boolean);
    const order = parseLines(root.dataset.order).map(norm);
    const exclude = parseLines(root.dataset.exclude).map(norm);
    const hideSingle = root.dataset.hideSingle !== 'false';
    const showCurrent = root.dataset.showCurrent !== 'false';
    const opts = {
      cta: root.dataset.cta || 'Δες το προϊόν',
      soldout: root.dataset.soldout || 'Εξαντλήθηκε',
      showPrice: root.dataset.showPrice !== 'false',
      addText: root.dataset.addText || '',
      addPrompt: root.dataset.addPrompt || '',
      addedText: root.dataset.addedText || 'Προστέθηκε στο καλάθι',
    };
    const section = root.getAttribute('data-atw-variant') === 'section';
    /* Σελίδα προϊόντος: σειρές με εικόνα (ίδια δομή με την ενότητα του quick add, χωρίς το κείμενο εισαγωγής) */
    const rows = section || root.dataset.layout === 'rows';
    const currentHandle = root.dataset.handle || '';

    const labelFor = (p) => {
      const hay = norm(suffixOf(p.title) + ' ' + p.type);
      const hit = mapping.find((m) => hay.includes(m.k));
      return hit ? hit.v : p.type || '';
    };

    let products;
    try {
      products = await fetchSiblings(name);
    } catch (_) {
      return;
    }

    const wanted = norm(name);
    const currentProduct = products.find((p) => p.handle === currentHandle);
    const currentLabel = currentProduct ? norm(labelFor(currentProduct)) : '';
    const items = [];
    const seen = new Set();
    products.forEach((p) => {
      if (norm(scentName(p.title)) !== wanted) return;
      const hay = norm(p.title);
      if (exclude.some((x) => hay.includes(x))) return;
      const label = labelFor(p);
      if (!label) return;
      const key = norm(label);
      /* Η μορφή που βλέπει ήδη ο πελάτης (π.χ. κερί) δεν προσφέρεται ξανά */
      if (!showCurrent && currentLabel && key === currentLabel && p.handle !== currentHandle) return;
      if (seen.has(key)) return;
      seen.add(key);
      items.push({ ...p, label, current: p.handle === currentHandle });
    });

    items.sort((a, b) => {
      const ia = order.indexOf(norm(a.label));
      const ib = order.indexOf(norm(b.label));
      return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
    });

    const visible = showCurrent ? items : items.filter((i) => !i.current);
    const others = items.filter((i) => !i.current);
    if (!others.length) {
      if (hideSingle) root.hidden = true;
      root.classList.remove('is-loading');
      return;
    }

    const list = root.querySelector('[data-atw-formats-list]');
    list.textContent = '';

    if (section && !root.querySelector('.atw-formats__head') && (root.dataset.qaEyebrow || root.dataset.qaText)) {
      const head = document.createElement('div');
      head.className = 'atw-formats__head';
      if (root.dataset.qaEyebrow) {
        const eyebrow = document.createElement('span');
        eyebrow.className = 'atw-formats__eyebrow';
        eyebrow.textContent = root.dataset.qaEyebrow;
        head.append(eyebrow);
      }
      if (root.dataset.qaText) {
        const text = document.createElement('p');
        text.className = 'atw-formats__text';
        text.textContent = root.dataset.qaText;
        head.append(text);
      }
      root.insertBefore(head, list);
    }

    visible.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'atw-formats__li';
      if (item.current) {
        const span = document.createElement('span');
        span.className = 'atw-formats__item is-current';
        span.setAttribute('aria-current', 'true');
        span.textContent = item.label;
        li.append(span);
      } else if (rows) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'atw-formats__item atw-formats__row' + (item.available ? '' : ' is-soldout');
        btn.setAttribute('aria-haspopup', 'dialog');
        const thumb = document.createElement('span');
        thumb.className = 'atw-formats__thumb';
        if (item.img) {
          const img = document.createElement('img');
          img.src = item.img;
          img.alt = '';
          img.loading = 'lazy';
          thumb.append(img);
        }
        const meta = document.createElement('span');
        meta.className = 'atw-formats__meta';
        const kind = document.createElement('span');
        kind.className = 'atw-formats__kind';
        kind.textContent = item.label;
        const price = document.createElement('span');
        price.className = 'atw-formats__price';
        price.textContent = item.available ? (opts.showPrice ? money(item.price) : '') : opts.soldout;
        meta.append(kind, price);
        const plus = document.createElement('span');
        plus.className = 'atw-formats__plus';
        plus.setAttribute('aria-hidden', 'true');
        plus.textContent = '+';
        btn.append(thumb, meta, plus);
        btn.addEventListener('click', () => openDialog(item, opts, btn));
        li.append(btn);
      } else {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'atw-formats__item' + (item.available ? '' : ' is-soldout');
        btn.textContent = item.label;
        btn.setAttribute('aria-haspopup', 'dialog');
        btn.addEventListener('click', () => openDialog(item, opts, btn));
        li.append(btn);
      }
      list.append(li);
    });
    root.classList.remove('is-loading');
    root.classList.add('is-ready');
  };

  const init = () => document.querySelectorAll('[data-atw-formats]').forEach(build);
  window.AtwFormats = { init };

  /* ---------- Quick add (native παράθυρο επιλογών) ---------- */
  /* Το native quick add του theme στο κινητό κρατά μόνο τίτλο, τιμή, επιλογές και φόρμα.
     Προσθέτουμε μόνο το πλαίσιο είδους και το τρίπτυχο, όπως στην κάρτα. Ο επιλογέας μορφών
     ΔΕΝ μπαίνει πια στο παράθυρο (rollback 02/10). */
  const patchQuickAdd = (C) => {
    if (!C || C.prototype.__atwFormatsPatched) return;
    C.prototype.__atwFormatsPatched = true;
    const original = C.prototype.updateQuickAddModal;
    C.prototype.updateQuickAddModal = async function (grid) {
      const found = grid && grid.querySelector ? grid.querySelector('[data-atw-formats]') : null;
      const keep = found ? found.cloneNode(true) : null;
      const result = await original.call(this, grid);
      const modal = document.getElementById('quick-add-modal-content');
      if (modal) decorate(modal, this, keep);
      return result;
    };
  };

  const decorate = (modal, qa, keep) => {
    const card = qa.closest ? qa.closest('product-card') : null;
    const header = modal.querySelector('.product-header');
    const titleEl = header ? header.querySelector('a') : modal.querySelector('.view-product-title');

    /* Καθαρός τίτλος (μόνο το όνομα αρώματος), όπως στην κάρτα */
    if (header && titleEl) {
      const cardTitle = card && card.querySelector('.atw-card-field__title');
      const clean = (cardTitle && cardTitle.textContent.trim()) || scentName(qa.dataset.productTitle || '');
      if (clean) titleEl.textContent = clean;
    }

    /* Πλαίσιο είδους + αρωματικό τρίπτυχο, όπως στην κάρτα */
    modal.querySelectorAll('.atw-qa-meta').forEach((n) => n.remove());
    if (titleEl) {
      const clean = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
      /* Πηγή 1: η κάρτα που άνοιξε το quick add. Πηγή 2: κάρτα του ίδιου προϊόντος οπουδήποτε στη σελίδα.
         Πηγή 3: τα δεδομένα που φέρνει το block της σελίδας προϊόντος (ισχύει και όταν δεν υπάρχει κάρτα). */
      let src = card;
      if (!src) {
        try {
          const path = new URL(qa.productPageUrl, location.origin).pathname;
          const link = [...document.querySelectorAll('a[href*="/products/"]')].find((a) => {
            try {
              return new URL(a.href, location.origin).pathname === path && a.closest('.atw-product-card, product-card, li, article');
            } catch (_) {
              return false;
            }
          });
          src = link && link.closest('.atw-product-card, product-card, li, article');
        } catch (_) {
          src = null;
        }
      }
      let typeText = src ? clean(src.querySelector('.atw-card-field__type')) : '';
      let tripText = src ? clean(src.querySelector('.atw-card-field__triptych')) : '';
      const data = modal.querySelector('[data-atw-formats]') || keep;
      if (data && data.dataset) {
        if (!typeText) typeText = data.dataset.kindLabel || '';
        if (!tripText) tripText = data.dataset.triptych || '';
      }
      if (typeText || tripText) {
        const meta = document.createElement('div');
        meta.className = 'atw-qa-meta';
        if (typeText) {
          const t = document.createElement('span');
          t.className = 'atw-qa-meta__type';
          t.textContent = typeText;
          meta.append(t);
        }
        if (tripText) {
          const p = document.createElement('p');
          p.className = 'atw-qa-meta__triptych';
          p.textContent = tripText;
          meta.append(p);
        }
        titleEl.insertAdjacentElement('afterend', meta);
      }
    }

    /* Ο επιλογέας μορφών δεν εμφανίζεται μέσα στο quick add */
    modal.querySelectorAll('[data-atw-formats]').forEach((n) => n.remove());
  };
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('quick-add-component').then(() => patchQuickAdd(customElements.get('quick-add-component')));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
